export const groupByFieldDropDown = <T>(
  data: T[],
  groupBy: keyof T | ((item: T) => string)
): Record<string, T[]> => {
  const groupFn =
    typeof groupBy === 'function' ? groupBy : (item: T) => String(item[groupBy])
  return Object.groupBy(data, groupFn)
}

export const getFieldValue = <T>(
  item: T,
  field: keyof T | ((item: T) => any)
): any => {
  if (typeof field === 'function') {
    return field(item)
  }
  return item[field]
}
